module.exports = __webpack_public_path__ + "static/media/addFundsGraphic.b177339a.svg";